// extracted by mini-css-extract-plugin
module.exports = {"base":"KatoButton_base__x0xaN","circle":"KatoButton_circle__uBGiw","icon":"KatoButton_icon__MG_3D","arrow":"KatoButton_arrow__bnvqU","buttonText":"KatoButton_buttonText__eLXK1"};